<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-title">
        <h1 class="title">{{ t('ログイン') }}</h1>
      </div>
      <Login />
      <div class="register-link">
        <span>{{ t('アカウントをお持ちでない方は') }}</span>
        <router-link to="/register">{{ t('会員登録') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Login from '@/components/organisms/Login/Login.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserLoginPage',
  mixins: [t],
  components: {
    Login,
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  justify-content: center;
  padding: 40px 16px 0px 16px;

  .login-title {
    text-align: center;
    margin-bottom: 25px;
    .title {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .login-container {
    width: 600px;
    max-width: 100%;
  }

  .register-link {
    text-align: center;
    margin-top: 50px;
    font-size: 14px;
    a {
      color: #2fa7d7 !important;
      text-decoration: underline;
      font-weight: normal;
      margin-left: 4px;
      transition: 0.3s;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .login-page {
    padding: 20px 10px;
  }
}
</style>
